


























import { Component, Prop, Vue } from 'vue-property-decorator'
import CheckSheetItem from './PrintReportCheckSheetItem.vue'
import { get } from 'lodash'

interface KeyPairItem {
  valueKey: string
  label: string
  labelAsSuffix: boolean
  type: string
  col: number
}

@Component({
  components: {
    CheckSheetItem
  }
})
export default class CheckSheetItemRow extends Vue {

  @Prop({
    required: true
  })
  value!: any

  @Prop({
    default: ''
  })
  label!: string

  @Prop({
    default: false
  })
  compact!: boolean

  @Prop({
    default: () => ['Good', 'Defective']
  })
  conditions!: string[]

  @Prop({
    default: () => ['Replaced', 'Need Replacement']
  })
  actions!: string[]

  private get conditionItems(): KeyPairItem[] {
    return CheckSheetItemRow.parse.apply(null, this.conditions)
  }

  private get actionItems(): KeyPairItem[] {
    return CheckSheetItemRow.parse.apply(null, this.actions)
  }

  private val(key: KeyPairItem): any|undefined {
    return get(this.value, key.valueKey, undefined)
  }

  private width(kp: KeyPairItem, of: KeyPairItem[]) {
    let ratio = 0
    if (of.length === 0) {
      ratio = 100
    } else if (kp.col === 0) {
      ratio = 1 / of.length
    } else {
      ratio = kp.col / (of.reduce((c, kp) => c + kp.col, 0) + 0.00001)
    }
    return {
      width: `${ratio * 100}%`
    }
  }

  /* ======= KEY PAIRS (for CheckSheetGroupRow) ======== */

  /**
   * FIXME: Move this to CheckSheetGroupRow
   * 
   * Convert formatted key
   * 
   * Each key has following format: 
   * 
   *  [col=0]#[type=bool]![key=label.replace(/ /g, '_').toLowerCase()];$?Label
   * 
   */
  private static parse(...encoded: string[]): KeyPairItem[] {
    return encoded.map((raw) => {
      const m = raw.match(/((\d+)\#)?((.*)\!)?((.*)\;)?(.*)/)
      const labelWithPlacement = m![7]
      const labelAsSuffix = labelWithPlacement.startsWith('$')
      const label = labelWithPlacement.replace(/^\$/, '')
      const col = +m![2] || 0
      const type = m![4] || 'bool'                                      // extract type - default to 'bool'
      const valueKey = m![6] || label.replace(/ /g, '_').toLowerCase()  // create slug
      return {
        label,
        valueKey,
        type,
        labelAsSuffix,
        col
      }
    })
  }
}
